import React from "react";
import { Container, Box } from "@mui/material";
import { ItemDetails } from "../../components/Item/ItemDetails";

export const InvItemDetailsPage = () => {
  return (
    <Box  
          sx={{
            minHeight:'100vh',
            background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
          }}
        >
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <ItemDetails />
      </Box>
    </Container>
    </Box>
  );
};
